import React from 'react';
import SkeletonBox from './SkeletonBox';
import './AuthFormSkeleton.css';

const AuthFormSkeleton = () => (
  <div className="authSkeleton">
    <div className="authSkeleton__image">
      <SkeletonBox width="100%" height="100%" radius="0" />
    </div>
    <div className="authSkeleton__panel">
      <div className="authSkeleton__form">
        <SkeletonBox width="220px" height="32px" />
        <SkeletonBox width="260px" height="16px" className="authSkeleton__mt8" />

        <SkeletonBox width="120px" height="13px" className="authSkeleton__mt24" />
        <SkeletonBox width="100%" height="48px" radius="10px" className="authSkeleton__mt8" />

        <SkeletonBox width="100%" height="48px" radius="42px" className="authSkeleton__mt20" />

        <div className="authSkeleton__divider">
          <SkeletonBox width="100%" height="1px" radius="0" />
        </div>

        <SkeletonBox width="100%" height="46px" radius="10px" className="authSkeleton__mt12" />
        <SkeletonBox width="100%" height="46px" radius="10px" className="authSkeleton__mt12" />
      </div>
    </div>
  </div>
);

export default AuthFormSkeleton;
